import './home-container.css';
import textlogo from '../../../static/textlogo.png'
import { useHistory }  from 'react-router-dom';

const Homecontainer = ( {signedIn} ) => {
  const history = useHistory()

  const handleUploadSurvey = () => {
      if (signedIn) {
        history.push("/upload")
      } else {
        history.push("/sign-in")
      }
  }

  return(
    <div class="home-container">
                <div class="left-container">
                    <h1>An exclusive survey collection platform for UW students and researchers.
                    </h1>
                    <p>Upload your surveys. Keep working. Come back and get results. Log in with your UW NetID to get started.
                    </p>
                </div>
                <div class="right-container">
                    <img id="ontheupload" src={textlogo} alt="HuaPsych"/>
                    <button id="upload" onClick={() => handleUploadSurvey()}>Upload a survey</button>
                </div>
            </div>
  )
}

export default Homecontainer;